import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Collapsible } from '@/components/ui/Accordion/Collapsible';
import { FlatAccordionHead } from '@/components/ui/Accordion/FlatAccordion/FlatAccordionHead';
export const FlatAccordion = (props) => {
    const { children, className = '', headComponent, isOpen, onChangeToggle, transitionTime, } = props;
    return (_jsxs("div", Object.assign({ className: className }, { children: [_jsx(FlatAccordionHead, Object.assign({ isOpen: isOpen, onChangeToggle: onChangeToggle }, { children: headComponent })), _jsx(Collapsible, Object.assign({ isOpen: isOpen, transitionTime: transitionTime }, { children: children }))] })));
};
